<template>
  <VModal :disable-backdrop-click="true" @close="onClose">
    <template #default="modalProps">
      <div class="mx-auto bg-white rounded-lg text-left shadow-xl lg:max-w-lg sm:w-full">
        <div class="flex flex-col divide-y">
          <div class="flex-none p-4">
            <div class="flex justify-between items-center">
              <div class="flex-1">Manage media item</div>
              <div class="flex-none flex space-x-3">
                <button
                  type="button"
                  class="rounded-md text-gray-400 hover:text-gray-500 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500"
                  @click="modalProps.close"
                >
                  <span class="sr-only">Close</span>
                  <svg
                    class="inline-flex h-6 w-6"
                    xmlns="http://www.w3.org/2000/svg"
                    fill="none"
                    viewBox="0 0 24 24"
                    stroke="currentColor"
                    aria-hidden="true"
                  >
                    <path
                      stroke-linecap="round"
                      stroke-linejoin="round"
                      stroke-width="2"
                      d="M6 18L18 6M6 6l12 12"
                    />
                  </svg>
                </button>
              </div>
            </div>
          </div>
          <div class="flex-1 p-4">
            <BaseFetchData :action="fetchData">
              <template #default="fetchDataProps">
                <div v-if="fetchDataProps.status.resolved" class="space-y-8">
                  <ReplaceMediaForm
                    v-if="mediaItem.mediablesCount"
                    :current-media-item="mediaItem"
                    @replacing="disabled = true"
                    @replaced="fetchDataProps.fetchData"
                    @finished="disabled = false"
                    @success="fetchDataProps.fetchData"
                  />
                  <DeleteMediaItemForm
                    :media-item="mediaItem"
                    @deleting="disabled = true"
                    @deleted="onMediaItemDeleted().then(modalProps.close)"
                    @finished="disabled = false"
                  />
                </div>
                <div v-else-if="fetchDataProps.status.loading" class="text-center">
                  <Loader />
                </div>
                <div v-else>Failed loading media item.</div>
              </template>
            </BaseFetchData>
          </div>
        </div>
      </div>
    </template>
  </VModal>
</template>

<script>
import { mediaLibraryMediaClient } from '@/api/clients/admin';
import ReplaceMediaForm from './ReplaceMediaForm.vue';
import DeleteMediaItemForm from './DeleteMediaItemForm.vue';

export default {
  name: 'DeleteMediaDialog',
  components: { ReplaceMediaForm, DeleteMediaItemForm },
  props: {
    mediaItemId: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      mediaItem: null,
      newMediaItem: null,
      disabled: false,
    };
  },
  methods: {
    onClose() {
      this.$emit('close');
    },
    fetchData() {
      return mediaLibraryMediaClient
        .read(this.mediaItemId, {
          include: 'mediables_count',
        })
        .then((response) => {
          this.mediaItem = response.data;
        });
    },
    async onMediaItemDeleted() {
      this.$emit('deleted');
      return Promise.resolve();
    },
  },
};
</script>
